<!-- apps/frontend/src/components/flow/nodes/AskAgentNode.vue -->
<template>
  <div :class="['group bg-gray-700 border-2 rounded-lg shadow-lg w-64 relative overflow-visible',
                selected ? 'border-cyan-400' : data.__validationError ? 'border-red-500' : 'border-gray-600']">
    <div class="bg-gray-800 p-3 rounded-t-lg flex items-center gap-2 justify-between">
      <div class="flex items-center gap-2">
        <span class="material-icons text-cyan-400">psychology_alt</span>
        <strong class="text-white text-sm">{{ $t('flowEditor.palette.askAgent') }}</strong>
      </div>
      <ExitNodeBadge :active="data.__isExitNode" />
      <ValidationMarker :error="data.__validationError" />
    </div>
    <div class="p-3 flex flex-col gap-1">
      <!-- Un nodo in JSON scrive un oggetto, non una stringa: a valle cambia
           tutto, e sulla tela i due casi sarebbero altrimenti identici. Stessa
           forma del badge di SendWhatsappNode: una sola grammatica visiva per
           "questo nodo si comporta in una variante". -->
      <span
        v-if="data.outputFormat === 'json'"
        class="self-start inline-flex items-center gap-1 text-[10px] uppercase tracking-wide bg-cyan-900/50 text-cyan-300 border border-cyan-700 rounded px-1.5 py-0.5"
      >
        <span class="material-icons" style="font-size:12px;">data_object</span>
        JSON
      </span>
      <p class="text-gray-400 text-xs truncate">{{ data.prompt || $t('flowEditor.askAgentEditor.noPrompt') }}</p>
      <p v-if="data.outputVariable" class="text-gray-400 text-xs font-mono truncate">→ {{ data.outputVariable }}</p>
    </div>
    <Handle type="target" :position="Position.Left" />
    <!-- Ramo di successo: resta l'handle SENZA id, cosi' gli edge gia' salvati
         (sourceHandle null) continuano a partire da qui. Vue Flow risolve un
         sourceHandle nullo con il PRIMO handle source del nodo (getEdgeHandle:
         `!handleId ? bounds[0] : ...`), quindi l'ordine qui sotto e' vincolante:
         spostare "error" prima farebbe saltare tutti i collegamenti esistenti
         sul ramo di errore, senza nessun errore visibile. -->
    <Handle type="source" :position="Position.Right" :style="{ top: '35%' }">
      <div class="absolute left-full ml-3 top-1/2 -translate-y-1/2 whitespace-nowrap text-xs bg-green-900 text-green-300 px-2 py-1 rounded-sm pointer-events-none">{{ $t('flowEditor.nodes.askAgentNode.successLabel') }}</div>
    </Handle>
    <!-- Ramo errore: se non e' collegato, il nodo prosegue sul ramo normale con
         la variabile vuota, come ha sempre fatto. -->
    <Handle id="error" type="source" :position="Position.Right" :style="{ top: '65%' }">
      <div class="absolute left-full ml-3 top-1/2 -translate-y-1/2 whitespace-nowrap text-xs bg-red-900 text-red-300 px-2 py-1 rounded-sm pointer-events-none">{{ $t('flowEditor.nodes.askAgentNode.errorLabel') }}</div>
    </Handle>
    <AddNodeButton v-if="!hasOutgoingEdge" placement="success" @add="emit('add-node', nodeId)" />
  </div>
</template>
<script setup>
import { Handle, Position } from '@vue-flow/core';
import ExitNodeBadge from './ExitNodeBadge.vue';
import AddNodeButton from './AddNodeButton.vue';
import ValidationMarker from './ValidationMarker.vue';
const emit = defineEmits(['add-node']);
defineProps({
  data:            { type: Object,  required: true },
  selected:        { type: Boolean, default: false },
  nodeId:          { type: String,  required: true },
  hasOutgoingEdge: { type: Boolean, default: false },
});
</script>
